/** @jsx React.DOM */
var React = require('react/addons')

var AccountLink = React.createClass({displayName: 'AccountLink',
  render: function() {
    return React.DOM.span(null, 
      React.DOM.a({href: '#/wrt/accounts/' + this.props.id, title: this.props.id}, 
        this.props.id
      )
    )
  }
})

module.exports = AccountLink



//////////////////
// WEBPACK FOOTER
// ./src/partials/wrt/account-link.jsx
// module id = 477
// module chunks = 0